import React, { useState } from "react";
import useForm from "react-hook-form";
import { translator } from "../../utils/i18n";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword, login } from "../../utils/session";
import { Trans } from "@lingui/macro";
import CloseIcon from "@material-ui/icons/Close";
import { Button, Tooltip } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { closeMainDialog } from "../../actions";
import { initValues } from "../../utils/fetcher";

function ConnexionPatientArea() {
  const { handleSubmit, register, errors, getValues } = useForm();

  const dispatch = useDispatch();
  const message = useSelector(state => state.messageWithCode);
  const messageConnexion = useSelector(state => state.message);
  const [messageRequiredEmail, setMessageRequiredEmail] = useState("");
  const connexionPatient = values => dispatch(login(values));
  const forgetPassword = email => dispatch(forgotPassword({ email: email }));
  const noClose = initValues().noClose;

  const forgetPasswordFunc = email => {
    setMessageRequiredEmail("");
    if (!email) {
      setMessageRequiredEmail(translator()._("CP_RESET_PW_TEXT"));
    } else {
      forgetPassword(email);
    }
  };

  const onSubmit = values => {
    setMessageRequiredEmail("");
    connexionPatient(values);
  };

  const closeHandler = () => {
    window.parent.postMessage({ event_id: "closeiframe" }, "*");
    dispatch(closeMainDialog());
  };

  return (
    <div className="wrap-form-login">
      {!noClose && (
        <Tooltip
          className="close-custom-btn"
          title={translator()._("W_STEP_BOUTON_FERMER")}
        >
          <IconButton
            aria-label={translator()._("W_STEP_BOUTON_FERMER")}
            onClick={closeHandler}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      )}
      <div className="column-left">
        <img className="logo" src="images/icon_cp.png" alt="Compte patient" />
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="form-login">
        {messageConnexion && (
          <div className="custom-message custom-alert d-flex align-items-center mb-10">
            <ErrorIcon />
            {messageConnexion}
          </div>
        )}
        {message && !messageRequiredEmail && message.text && (
          <div
            className={
              message.code === 1
                ? "custom-message custom-success d-flex align-items-center mb-10"
                : "custom-message custom-alert d-flex align-items-center mb-10"
            }
          >
            {message.code === 1 ? <CheckCircleIcon /> : <ErrorIcon />}
            <div dangerouslySetInnerHTML={{ __html: message.text }} />
          </div>
        )}
        {messageRequiredEmail && (
          <div className="custom-message custom-alert d-flex align-items-center mb-10">
            <ErrorIcon />
            {messageRequiredEmail}
          </div>
        )}
        <div className="row-form">
          <input
            type="email"
            placeholder={translator()._("W_STEP4_FORMULAIRE_EMAIL")}
            name="email"
            ref={register({
              required: `${translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}`,
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: `${translator()._("W_ADRESSE_E_MAIL_NON_VALIDE")}`
              }
            })}
          />
          <span className="error">{errors.email && errors.email.message}</span>
        </div>
        <div className="row-form">
          <input
            placeholder={translator()._("CP_PASSWORD")}
            name="password"
            type="password"
            ref={register({
              required: `${translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}`
            })}
          />
          <span className="error">
            {errors.password && errors.password.message}
          </span>
        </div>
        <div>
          <button
            type="button"
            onClick={() => forgetPasswordFunc(getValues().email)}
            className="forgot-password no-style-btn"
          >
            <Trans id="W_STEP4_ACCES_MEMBRE_MOT_DE_PASSE_OUBLIE" />
          </button>
        </div>
        <Button
          color="primary"
          type="submit"
          className="btn-filled"
          variant="contained"
        >
          {translator()._("W_SE_CONNECTER")}
        </Button>
      </form>
    </div>
  );
}

export default ConnexionPatientArea;
